module.exports = __webpack_public_path__ + "img/discussion_vote_heart_line.aa69c470.svg";